/* ================================================
   Theme JS — Shopify AJAX Cart API
   ================================================ */

window.theme = (function() {

  /* ---- Cart open / close ---- */
  function openCart() {
    document.getElementById('cartDrawer').classList.add('open');
    document.getElementById('cartOverlay').classList.add('open');
    document.getElementById('cartDrawer').setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    document.getElementById('cartDrawer').classList.remove('open');
    document.getElementById('cartOverlay').classList.remove('open');
    document.getElementById('cartDrawer').setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---- Fetch cart from Shopify and re-render drawer ---- */
  async function refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error('Cart refresh failed:', err);
    }
  }

  /* ---- Add item to cart ---- */
  async function addToCart(variantId, btn) {
    const originalText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    try {
      const response = await fetch(window.shopData.routes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!response.ok) {
        const err = await response.json();
        alert(err.description || 'Could not add item to cart.');
        return;
      }

      await refreshCart();
      openCart();
    } catch (err) {
      console.error('Add to cart failed:', err);
    } finally {
      if (btn) { btn.textContent = originalText; btn.disabled = false; }
    }
  }

  /* ---- Change line item quantity (0 = remove) ---- */
  async function updateCartItem(key, quantity) {
    try {
      await fetch(window.shopData.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      await refreshCart();
    } catch (err) {
      console.error('Cart update failed:', err);
    }
  }

  /* ---- Render cart drawer HTML ---- */
  function renderCartDrawer(cart) {
    const body     = document.getElementById('cartBody');
    const footer   = document.getElementById('cartFooter');
    const countEl  = document.getElementById('cartItemCount');

    if (countEl) countEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="btn btn-primary" id="startShoppingBtn">Start Shopping</a>
        </div>
      `;
      document.getElementById('startShoppingBtn').addEventListener('click', closeCart);
      if (footer) footer.style.display = 'none';
      return;
    }

    const itemsHtml = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <a href="${item.url}">
          ${item.image
            ? `<img class="cart-item-img" src="${item.image}" alt="${escapeHtml(item.title)}">`
            : `<div class="cart-item-img cart-item-img--placeholder"></div>`
          }
        </a>
        <div class="cart-item-details">
          <p class="cart-item-name">${escapeHtml(item.product_title)}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item-variant">${escapeHtml(item.variant_title)}</p>` : ''}
          <p class="cart-item-price">${formatMoney(item.final_price)}</p>
          <div class="cart-item-qty">
            <button onclick="window.theme.updateCartItem('${item.key}', ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="window.theme.updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
          </div>
          <button class="cart-item-remove" onclick="window.theme.updateCartItem('${item.key}', 0)">Remove</button>
        </div>
      </div>
    `).join('');

    body.innerHTML = itemsHtml;

    if (footer) {
      footer.style.display = 'block';
      const subtotalEl = document.getElementById('cartSubtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      // Ensure View Cart link is present after JS re-render
      if (!footer.querySelector('.cart-view-link')) {
        const viewCartLink = document.createElement('a');
        viewCartLink.href = '/cart';
        viewCartLink.className = 'btn btn-outline btn-full cart-view-link';
        viewCartLink.textContent = 'View Cart';
        viewCartLink.style.marginBottom = '8px';
        const checkoutBtn = footer.querySelector('.btn-primary');
        if (checkoutBtn && checkoutBtn.nextSibling) {
          footer.insertBefore(viewCartLink, checkoutBtn.nextSibling);
        }
      }
    }
  }

  /* ---- Cart count badge ---- */
  function updateCartCount(count) {
    const badge = document.getElementById('cartCount');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('visible', count > 0);
  }

  /* ---- Money formatter ---- */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return window.shopData.moneyFormat
      ? window.shopData.moneyFormat.replace('{{amount}}', amount).replace('{{ amount }}', amount)
      : '$' + amount;
  }

  /* ---- HTML escape helper ---- */
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---- Init event listeners ---- */
  document.addEventListener('DOMContentLoaded', function() {
    const cartToggle = document.getElementById('cartToggle');
    const closeBtn   = document.getElementById('closeCart');
    const overlay    = document.getElementById('cartOverlay');
    const searchBtn  = document.getElementById('searchToggle');
    const searchBar  = document.getElementById('searchBar');
    const continueBtn = document.getElementById('continueShoppingBtn');

    if (cartToggle) cartToggle.addEventListener('click', openCart);
    if (closeBtn)   closeBtn.addEventListener('click', closeCart);
    if (overlay)    overlay.addEventListener('click', closeCart);
    if (continueBtn) continueBtn.addEventListener('click', closeCart);

    if (searchBtn && searchBar) {
      searchBtn.addEventListener('click', function() {
        searchBar.classList.toggle('open');
        if (searchBar.classList.contains('open')) {
          searchBar.querySelector('input').focus();
        }
      });
    }

    // Close cart on ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeCart();
    });
  });

  return { openCart, closeCart, addToCart, updateCartItem, refreshCart };

})();
